import { getI18n } from 'react-i18next';
import {call, fork, put, take} from 'redux-saga/effects';
import { onEnqueueErrorSnackbar } from './enqueueSnackbarFlow';
import {Action} from 'redux-actions';
import {
    CreateNewOrderPayload,
    createNewOrder,
} from '../action/bookingsCommands';
import {Api} from '../api';
import Logger from '../common/logger';
import {Booking, CreateNewOrderData} from '../api/types';
import { visitorBookingWindow } from '../utils/visitorBookingWindow';
import { guestBookingFetched } from '../action/bookingsEvents';

export const onCreateNewOrder = function* (orderData: CreateNewOrderPayload) {
    // The same window the confirmation ticket showed (`BookingPage`).
    const bookingWindow = visitorBookingWindow(
        orderData.fromDate, orderData.bookingTime, orderData.duration, orderData.timeZone,
    );
    if (!bookingWindow) {
        yield fork(onEnqueueErrorSnackbar, getI18n().t('book_location.error.create_reservation'));
        return;
    }

    const orderPayload: CreateNewOrderData = {
        groupId: orderData.groupId,
        amount: 1,
        fromDate: bookingWindow.fromDate.toISOString(),
        toDate: bookingWindow.toDate.toISOString(),
        comment: orderData.comment,
        contactData: orderData.contactData,
        isGuestBooking: orderData.isGuestBooking,
    };
    try {
        const booking: Booking = yield call(Api.createNewOrder, orderPayload);

        yield put(guestBookingFetched({ booking }));

    } catch (error) {
        Logger('Saga').error(error);
        yield fork(onEnqueueErrorSnackbar, getI18n().t('book_location.error.create_reservation'));
    }
};

export function* createNewOrderFlow() {
    while (true) {
        const action: Action<CreateNewOrderPayload> = yield take(createNewOrder.toString());
        yield fork(onCreateNewOrder, action.payload);
    }
}
